import React, { useEffect, useState, useContext, useLayoutEffect, useCallback } from 'react'
import '../css/sb-admin-2.min.css'
import '../css/sb-admin-2.css'


import $ from 'jquery';
import { AppColors } from '../css/AppColors';
import { apiRequest } from '../utils/apiCalls';
import { Modal, Button } from 'react-bootstrap';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import { Context } from '../Context/DataContext';
import { FaClipboardList, FaPencilAlt, FaTrash, FaFileInvoiceDollar } from 'react-icons/fa'
import { Link } from 'react-router-dom';
import { setDefaultLocale } from 'react-datepicker';
import { useHistory } from 'react-router-dom';

import refreshIcon from '../img/refreshIcon.svg';


const useForceUpdate = () => {
    const [, updateState] = React.useState();
    return useCallback(() => updateState({}), []);
}


const ViewCustomers = (props) => {



    const forceUpdate = useForceUpdate()
    const history = useHistory();
    const { state, setCustomersGlobal, setStoreData } = useContext(Context)
    const [loading, setLoading] = useState(false)
    const [customers, setCustomers] = useState(state.customers ? state.customers : [])
    const [val, setVal] = useState(0)
    const [delCustModal, setDelCustModal] = useState(false)
    const [delCustId, setDelCustId] = useState('')

    function getCustomers() {

        setLoading(true)
        var st_id;
        st_id = state.storeData.st_id
        console.log('store data is')
        console.log(state.storeData)
        console.log('st_id is  = ')
        console.log(st_id)





        apiRequest({ st_id: st_id }, 'viewcustomers')
            .then(data => {
                setLoading(false)
                if (data.status == 1) {
                    setCustomers(data.data)
                    setCustomersGlobal(data.data)
                }

            })
            .catch(err => {
                setLoading(false)
                console.log(err)
            })
    }


    function delCust() {
        setLoading(true)
        const reqObj = {
            cust_id: delCustId
        }
        apiRequest(reqObj, 'delcust')
            .then(data => {
                setLoading(false)
                console.log(data)
                if (data.status == '1') {
                    setLoading(false)
                    alert('Customer Deleted')
                    getCustomers();
                }
                else alert(data.error)
            })
            .catch(err => {
                setLoading(false)
                alert('Internet Error')
            })
    }






    useEffect(() => {

        if (!state.customers.length) {
            getCustomers()
        }
        
        console.log(state.customers)
        

        if (props.location?.state?.refresh) {
            if (props.location?.state?.customers) {
                setCustomers(props.location.state.customers)
                forceUpdate();
                return
            }
            getCustomers()
        }
    }, [])


    useEffect(() => {
        $(document).ready(function () {
            $('#dataTable').DataTable();
        });
    }, [loading])


    return (
        <div id="page-top">

            <div id="wrapper" >
                <Sidebar />
                <div id="content-wrapper" class="d-flex flex-column">
                    <div id="content">
                        <Topbar />


                        <div className="container-fluid" >


                            <Modal
                                show={delCustModal}
                                onHide={() => setDelCustModal(false)}
                            >
                                <Modal.Header>
                                    <Modal.Title style={{ fontSize: 18, textAlign: 'center', alignSelf: 'center', fontFamily: 'PSBo' }} >All the orders and prescription data will be deleted for this customer.</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p style={{ textAlign: 'center' }}>Are you sure you want to delete this customer?</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="secondary" onClick={() => {
                                            setDelCustId('')
                                            setDelCustModal(false)
                                        }}>No</Button>
                                    <Button
                                        style={{ fontFamily: 'PMe' }}
                                        variant="danger" onClick={() => {
                                            setDelCustModal(false)
                                            delCust()
                                        }}>Yes</Button>
                                </Modal.Footer>


                            </Modal>
                            <Modal

                                show={loading}
                            // onHide={() => setLoading(false)}
                            >

                                <Modal.Body class="text-center" >
                                    <div
                                        class="text-center"
                                        class="spinner-border text-center" style={{ margin: 10, color: AppColors.primary }} role="status"></div>
                                </Modal.Body>

                            </Modal>

                            {/* Page Heading */}
                            <div style={{ width: "100%", height: 65, }}>
                                <div style={{ float: "left", width: "50%" }}>
                                    <h1
                                        style={{ fontFamily: 'RSBo' }}
                                        className="h3 mb-2 text-gray-800 ">View Customers</h1>
                                    <br />
                                </div>

                                <div style={{ float: "right", display: 'flex', flexDirection: 'column', marginTop: -20 }}>
                                    <Button
                                        onClick={() => getCustomers()}
                                        className="rBBtn"
                                        style={{ width: 50, background: 'none', borderWidth: 0, float: 'right', alignSelf: 'center', marginRight: 10, borderColor: 'white' }}
                                    >
                                        <img src={refreshIcon} style={{ width: 20, color: 'red', }} />
                                    </Button>
                                    <Button
                                        className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"
                                        style={{ color: 'white', backgroundColor: AppColors.primary, borderWidth: 0, marginTop: 10, fontFamily: 'RBo', }}

                                    >
                                        <Link
                                            style={{ color: 'white', textDecorationLine: 'none', }}
                                            to="/addCustomer">
                                            Add Customer
                                        </Link>
                                    </Button>
                                </div>


                            </div>

                            {/* DataTales Example */}
                            <div className="card shadow mb-4" style={{ width: "100%" }} >
                                <div className="card-body">
                                    {
                                        !loading &&

                                        <div className="table-responsive">
                                            {/* table class="table table-bordered dt-responsive" id="dataTable" width="100%" cellspacing="0" */}

                                            <table
                                                id="dataTable"
                                                className="table table-striped table-bordered dt-responsive"
                                                style={{ width: "100%" }}
                                                cellSpacing={0}
                                            >
                                                <thead>
                                                    <tr>
                                                        <th className="tRow" >Name</th>
                                                        <th className="tRow">DOB</th>
                                                        <th className="tRow">Phone No</th>
                                                        <th className="tRow">Email</th>
                                                        {/* <th className="tRow">Address</th> */}
                                                        {/* <th className="tRow">Orders</th> */}
                                                        <th className="tRow">Prescription</th>
                                                        <th className="tRow">Best Contact</th>

                                                        <th className="tRow"> Action</th>

                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        customers?.map((v) => {
                                                            return (
                                                                <tr>
                                                                    <td className="tData">
                                                                        <Link
                                                                            className="tData"
                                                                            style={{ textDecorationLine: 'none' }}
                                                                            to={{
                                                                                pathname: "/ViewSingleCust",
                                                                                state: v
                                                                            }}
                                                                        >
                                                                            <nobr>{v.cust_fname + " " + v.cust_lname}</nobr>
                                                                        </Link>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <nobr>{v.cust_dob}</nobr>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <Link
                                                                            style={{ textDecorationLine: 'none' }}
                                                                            className="tData"
                                                                            to={{
                                                                                pathname: "/ViewSingleCust",
                                                                                state: v
                                                                            }}
                                                                        >

                                                                            <nobr>{v.cust_phone}</nobr>

                                                                        </Link>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <nobr>{v.cust_email}</nobr>
                                                                    </td>
                                                                    <td className="tData">
                                                                        <Link to=
                                                                            {{
                                                                                pathname: '/addPresciption',
                                                                                state: v
                                                                            }}
                                                                            className="tData" style={{ color: 'rgba(0,0,0,0.6)', fontSize: 15, fontFamily: 'PRe' }}
                                                                        >

                                                                            <nobr>Add/View</nobr>

                                                                        </Link>

                                                                    </td>
                                                                    {/* <td className="tData">
                                                                        {v.cust_address}
                                                                    </td> */}
                                                                    <td className="tData">
                                                                        <nobr>{v.cust_best_contact}</nobr>
                                                                    </td>
                                                                    {/* <td className="tData">
                                                                        <Link to=
                                                                            {{
                                                                                pathname: '/managePrescription',
                                                                                state: v.cust_id
                                                                            }}
                                                                            className="tData" style={{ color: 'rgba(0,0,0,0.6)', fontSize: 15, fontFamily: 'PRe' }} >
                                                                            Add/View({v.presc_total > 0 ? v.presc_total : 0})
                                                                        </Link>
                                                                    </td> */}
                                                                    <td>
                                                                        <nobr>
                                                                            <Link to={{
                                                                                pathname: "/ViewSingleCust",
                                                                                state: v
                                                                            }}
                                                                                className="btn" style={{ backgroundColor: '#54C2BB', }} >
                                                                                <FaClipboardList color="white" />
                                                                            </Link>{" "}

                                                                            <Link to={{
                                                                                pathname: "/editCustomer",
                                                                                state: v

                                                                            }} className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaPencilAlt color="white" />
                                                                            </Link>{" "}

                                                                            <Link title="Add Order" to={{
                                                                                pathname: "/viewOrder",
                                                                                // pathname: "/addOrder",
                                                                                state: {
                                                                                    cust_id: v.cust_id,
                                                                                    cust_fname : v.cust_fname,
                                                                                    cust_lname : v.cust_lname
                                                                                }

                                                                            }} className="btn" style={{ backgroundColor: '#54C2BB' }} >
                                                                                <FaFileInvoiceDollar color="white" size={20} />
                                                                            </Link>{" "}

                                                                            <Button
                                                                                onClick={() => {
                                                                                    setDelCustId(v.cust_id)
                                                                                    setDelCustModal(true)
                                                                                }}
                                                                                className="btn btn-danger">
                                                                                <FaTrash color="white" />
                                                                            </Button>
                                                                        </nobr>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }


                                                </tbody>
                                            </table>

                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >


    )
}



export default ViewCustomers
